/* eslint-disable key-spacing */

export default {
  onResize: { name: "resize", listener: "onResize" },
  onWebglcontextlost: { name: "webglcontextlost", listener: "onWebglcontextlost" },
  onWebglcontextrestored: { name: "webglcontextrestored", listener: "onWebglcontextrestored" },
  onRemove: { name: "remove", listener: "onRemove" },
  onMovestart: { name: "movestart", listener: "onMovestart" },
  onLoad: { name: "load", listener: "onLoad" },
  onContextmenu: { name: "contextmenu", listener: "onContextmenu" },
  onDblclick: { name: "dblclick", listener: "onDblclick" },
  onClick: { name: "click", listener: "onClick" },
  onTouchcancel: { name: "touchcancel", listener: "onTouchcancel" },
  onTouchmove: { name: "touchmove", listener: "onTouchmove" },
  onTouchend: { name: "touchend", listener: "onTouchend" },
  onTouchstart: { name: "touchstart", listener: "onTouchstart" },
  onDataloading: { name: "dataloading", listener: "onDataloading" },
  onMousemove: { name: "mousemove", listener: "onMousemove" },
  onMouseup: { name: "mouseup", listener: "onMouseup" },
  onMousedown: { name: "mousedown", listener: "onMousedown" },
  onSourcedataloading: { name: "sourcedataloading", listener: "onSourcedataloading" },
  onError: { name: "error", listener: "onError" },
  onData: { name: "data", listener: "onData" },
  onStyledata: { name: "styledata", listener: "onStyledata" },
  onSourcedata: { name: "sourcedata", listener: "onSourcedata" },
  onMouseout: { name: "mouseout", listener: "onMouseout" },
  onStyledataloading: { name: "styledataloading", listener: "onStyledataloading" },
  onMoveend: { name: "moveend", listener: "onMoveend" },
  onMove: { name: "move", listener: "onMove" },
  onRender: { name: "render", listener: "onRender" },
  onZoom: { name: "zoom", listener: "onZoom" },
  onZoomstart: { name: "zoomstart", listener: "onZoomstart" },
  onZoomend: { name: "zoomend", listener: "onZoomend" },
  onBoxzoomstart: { name: "boxzoomstart", listener: "onBoxzoomstart" },
  onBoxzoomcancel: { name: "boxzoomcancel", listener: "onBoxzoomcancel" },
  onBoxzoomend: { name: "boxzoomend", listener: "onBoxzoomend" },
  onRotate: { name: "rotate", listener: "onRotate" },
  onRotatestart: { name: "rotatestart", listener: "onRotatestart" },
  onRotateend: { name: "rotateend", listener: "onRotateend" },
  onDragend: { name: "dragend", listener: "onDragend" },
  onDrag: { name: "drag", listener: "onDrag" },
  onDragstart: { name: "dragstart", listener: "onDragstart" },
  onPitch: { name: "pitch", listener: "onPitch" },
  onIdle: { name: "idle", listener: "onIdle" }
};
